<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        <el-breadcrumb-item>角色管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">角色管理</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handleAdminCreate">添加角色</el-button>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <el-table :data="roles"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="id"
                         label="ID"
                         min-width="80"
                         align="center">
        </el-table-column>
        <el-table-column prop="title"
                         label="名称"
                         min-width="180"
                         align="center">
        </el-table-column>
        <el-table-column label="范围"
                         min-width="180"
                         align="center">
          <template slot-scope="scope">
            {{formateDatarange(scope.row.datarange)}}
          </template>
        </el-table-column>
        <!--      <el-table-column
          label="新媒体账号"
          min-width="180"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{formateMedia_account_ids(scope.row.media_accounts)}}
          </template>
        </el-table-column> -->
        <el-table-column prop="remark"
                         label="备注"
                         min-width="180"
                         align="center">
        </el-table-column>
        <el-table-column prop="create_time"
                         label="创建时间"
                         min-width="180"
                         align="center">
          <template slot-scope="scope">
            {{$moment(scope.row.create_time).format('YYYY/MM/DD HH:mm:SS')}}
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         width="160"
                         align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '正常' : '禁用'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="160"
                         align="center"
                         fixed="right"
                         v-if="isfixed">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="text"
                       @click="handleToRoleEdit(scope.row, scope.$index)">编辑</el-button>
            <el-button size="mini"
                       type="text"
                       @click="handleToRuleEdit(scope.row, scope.$index)">权限分配</el-button>
            <el-button size="mini"
                       style="color:#f56c6c"
                       type="text"
                       @click="handleToRoleDelete(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label=""
                         width="40"
                         align="center"
                         fixed="right"
                         v-else>
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                ...
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a"
                                  style="margin-bottom:6px;"><span @click="handleToRoleEdit(scope.row, scope.$index)"
                        style="font-size:16px;color: #409EFF;">
                    编辑
                  </span></el-dropdown-item>
                <el-dropdown-item command="b"
                                  style="margin-bottom:6px;"><span @click="handleToRuleEdit(scope.row, scope.$index)"
                        style="font-size:16px;color: #409EFF;">
                    权限分配
                  </span></el-dropdown-item>
                <el-dropdown-item command="d"
                                  style="margin-bottom:6px;"><span @click="handleToRoleDelete(scope.row, scope.$index)"
                        style="font-size:16px;color: #F56C6C;">
                    删除
                  </span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <RoleCreate :visible="createDialog"
                @close="createDialog=false"
                @submit="fetchAdminRoleList"></RoleCreate>
    <RoleEdit :visible="editDialog"
              :content="editRow"
              @close="editDialog=false"
              @submit="fetchAdminRoleList"></RoleEdit>
  </div>
</template>

<script>
import { adminRoleList, adminRoleDestroy } from '@/api/admin'
import RoleCreate from '@/components/dialog/admin/RoleCreate'
import RoleEdit from '@/components/dialog/admin/RoleEdit'
export default {
  components: {
    RoleCreate,
    RoleEdit,
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 1000,
      roles: [],
      editRow: {},
      isfixed: document.body.clientWidth < 820 ? false : true,
    }
  },
  created() {
    this.fetchAdminRoleList()
  },
  methods: {
    // 角色列表
    fetchAdminRoleList() {
      adminRoleList(this.query).then((res) => {
        this.roles = res.list || []
        this.pageTotal = res.count || 0
      })
    },
    handleAdminCreate() {
      this.createDialog = true
    },
    //分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchAdminRoleList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchAdminRoleList()
    },
    // 角色编辑
    handleToRoleEdit(row, index) {
      this.editRow = Object.assign({}, row, {
        status: row.status == 1 ? true : false,
      })
      this.editDialog = true
    },
    // 角色权限编辑
    handleToRuleEdit(item, index) {
      this.$router.push({ path: '/role/rules', query: { roleId: item.id } })
    },
    // 角色删除
    handleToRoleDelete(item, index) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          adminRoleDestroy({ id: item.id }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchAdminRoleList()
          })
        })
        .catch(() => {})
    },
    formateDatarange(datarange) {
      const obj = {
        1: '本人',
        2: '本部门',
        3: '本部门及下属部门',
        4: '全部',
        5: '本人产品',
        6: '新媒体账号',
        7: '本人专业数据范围',
        8: '本人邀请用户数据范围',
      }
      return obj[datarange] || '无'
    },
    formateMedia_account_ids(val) {
      if (val && val.length) {
        return val
          .map((v) => {
            return v.name
          })
          .join(',')
      } else {
        return ''
      }
    },
  },
}
</script>

<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>

